import Color from 'color';
import styled, {css} from 'styled-components';

import ChatSvg from '../../../../assets/icons/empty-state/chat.svg';
import LiveSvg from '../../../../assets/icons/empty-state/live.svg';
import {getColor, ms, square} from '../../../../styles';
import {Button} from '../../../../uikit/Button';
import {Text} from '../../../../uikit/Text';
import {View} from '../../../../uikit/View';

type StyledProps = {
  isB2bWidget?: boolean;
  isSmallUI: boolean;
};

type TransientStyledProps = {
  $isB2bWidget?: boolean;
  $isSmallUI: boolean;
};

export const Container = styled(View)`
  flex-direction: column;
  gap: ${ms(20)};
`;

export const SessionTypeContainer = styled(View)<{isB2bWidget: boolean}>`
  position: relative;
  padding: ${ms(20)};
  gap: ${ms(20)};
  border-radius: ${ms(20)};
  background-color: ${p =>
    Color(getColor(p.isB2bWidget ? 'global1' : 'global2')(p))
      .alpha(0.05)
      .toString()};
`;

export const SessionTypeContent = styled(View)<StyledProps>`
  flex-direction: column;
  gap: ${ms(12)};
`;

export const Title = styled(Text).attrs({weight: 'bold'})<StyledProps>`
  font-size: ${ms(20)};
  line-height: ${ms(28)};
  letter-spacing: ${ms(-0.46)};
  color: ${p => getColor(p.isB2bWidget ? 'global1' : 'global2')(p)};

  ${p =>
    p.isSmallUI &&
    css`
      width: 68%;
    `}
`;

export const Description = styled(Text)<StyledProps>`
  font-size: ${ms(14)};
  line-height: ${ms(20)};
  letter-spacing: ${ms(-0.46)};
`;

export const ScheduleButton = styled(Button).attrs<StyledProps>(p => ({
  scheme: p.isB2bWidget ? 'primary' : 'secondary',
}))<StyledProps>`
  border-radius: ${p => ms(p.isB2bWidget ? 999 : 8)};
  align-self: flex-start;
  padding-inline: ${ms(40)};
  margin-block-start: ${ms(4)};

  ${p =>
    p.isSmallUI &&
    css`
      align-self: stretch;
      padding-inline: 0;
      margin-block-start: 0;
    `}
`;

const iconStyle = css<TransientStyledProps>`
  ${square(134)};

  ${p =>
    p.$isSmallUI &&
    css`
      ${square(60)};
      position: absolute;
      right: ${ms(20)};
      top: ${ms(20)};
    `}
`;

export const LiveIcon = styled(LiveSvg).attrs<TransientStyledProps>(p => ({
  fill: getColor(p.$isB2bWidget ? 'global1' : 'global2')(p),
}))<TransientStyledProps>`
  ${iconStyle};
`;

export const ChatIcon = styled(ChatSvg).attrs<TransientStyledProps>(p => ({
  fill: getColor(p.$isB2bWidget ? 'global1' : 'global2')(p),
}))<TransientStyledProps>`
  ${iconStyle};
`;
